module.exports = __webpack_public_path__ + "media/mail/AppStore-1cfd5dba.svg";